import { post, get, put } from "../httpmethods";
import { URL_API } from "../config";

export const PetAPI = {
    createPet: async (body) => {
        return await post(`${URL_API}/pets`, body);
    },
    getPets: async (data) => {
        return await get(`${URL_API}/pets`, data);
    },
    getPetById: async (guid) => {
        return await get(`${URL_API}/pets/${guid}`);
    },
    deletePet: async (id) => {
        return await post(`${URL_API}/pets/${id}`);
    },
    updatePet: async (id, body) => {
        return await put(`${URL_API}/pets/${id}`, body);
    }
}
